import store from '@/store';

const MainLayout = () => import(/* webpackChunkName: "auth" */ '../../layouts/MainLayout');
// Rent
const RentsPage = () => import(/* webpackChunkName: "rent" */ '../../pages/rent/RentsPage');
const RentsListPage = () => import(/* webpackChunkName: "rent" */ '../../pages/rent/RentsListPage');
const RentPage = () => import(/* webpackChunkName: "rent" */ '../../pages/rent/RentPage');
// Booking
const BookingsPage = () => import(/* webpackChunkName: "booking" */ '../../pages/booking/BookingsPage');
const BookingsListPage = () => import(/* webpackChunkName: "booking" */ '../../pages/booking/BookingsListPage');
// Driver
const DriversPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriversPage');
const DriversListPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriversListPage');
const AddDriverPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/AddDriverPage');
const DriverPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverPage');
const DriverInfoPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverInfoPage');
const DriverAutosPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverAutosPage');
const DriverBalancePage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverBalancePage');
const DriverHistoryPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverHistoryPage');
const DriverFinesPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverFinesPage.vue');
const DriverDtpPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverDtpPage.vue');
const DriverRatingPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/DriverRatingPage.vue');
const RatingConfiguratorPage = () => import(/* webpackChunkName: "driver" */ '../../pages/driver/RatingConfiguratorPage.vue');
// Finance
const FinancePage = () => import(/* webpackChunkName: "finance" */ '../../pages/finance/FinancePage.vue');
const CompanyExpensesPage = () => import(/* webpackChunkName: "finance" */ '../../pages/finance/CompanyExpensesPage.vue');
const ConfiguratorPage = () => import(/* webpackChunkName: "finance" */ '../../pages/finance/ConfiguratorPage.vue');
const CompanyExpensesHistoryPage = () => import(/* webpackChunkName: "finance" */ '../../pages/finance/CompanyExpensesHistoryPage.vue');
// Settings
const SettingsPage = () => import(/* webpackChunkName: "settings" */ '../../pages/SettingsPage');
// Company
const CompaniesPage = () => import(/* webpackChunkName: "company" */ '../../pages/company/CompaniesPage');
const CompaniesListPage = () => import(/* webpackChunkName: "company" */ '../../pages/company/CompaniesListPage');
const AddCompanyPage = () => import(/* webpackChunkName: "company" */ '../../pages/company/AddCompanyPage');
const CompanyPage = () => import(/* webpackChunkName: "company" */ '../../pages/company/CompanyPage');
// Investor
const InvestorsPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/InvestorsPage');
const InvestorsListPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/InvestorsListPage');
const AddInvestorPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/AddInvestorPage');
const InvestorPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/InvestorPage');
const InvestorInfoPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/InvestorInfoPage');
const InvestorAutosPage = () => import(/* webpackChunkName: "investor" */ '../../pages/investor/InvestorAutosPage');
// Auto
const AutosPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutosPage');
const AutosListPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutosListPage');
const AddAutoPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AddAutoPage');
const AutoPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoPage');
const AutoInfoPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoInfoPage');
const AutoCurrentStatePage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoCurrentState');
const AutoRentsPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoRentsPage');
const AutoHistoryPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoHistoryPage');
const AutoRatesPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoRatesPage');
const AutoFinesPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoFinesPage.vue');
const AutoDtpPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoDtpPage.vue');
const InsuranceInspectionPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/InsuranceInspectionPage.vue');
const InternalMaintenancePage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/InternalMaintenancePage.vue');
const AutoInternalMaintenancePage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/AutoInternalMaintenancePage.vue');
const MaintenanceHistoryPage = () => import(/* webpackChunkName: "auto" */ '../../pages/auto/MaintenanceHistoryPage.vue');
// Workers-board
const WorkersBoard = () => import(/* webpackChunkName: "workers-list" */ '../../pages/workers-board/WorkersBoardPage.vue');
const WorkersBoardList = () => import(/* webpackChunkName: "workers-list" */ '../../pages/workers-board/WorkersBoardListPage.vue');
const WorkersHistoryPage = () => import(/* webpackChunkName: "workers-list" */ '../../pages/workers-board/WorkersHistoryPage.vue');
const WorkersStatisticsPage = () => import(/* webpackChunkName: "workers-list" */ '../../pages/workers-board/WorkersStatisticsPage.vue');
// Investor-board
const InvestorBoard = () => import(/* webpackChunkName: "investor-board" */ '../../pages/investor-board/InvestorBoardPage.vue');
const InvestorBoardList = () => import(/* webpackChunkName: "investor-board-list" */ '../../pages/investor-board/InvestorBoardListPage.vue');
const InvestorStatistics = () => import(/* webpackChunkName: "investor-board-list" */ '../../pages/investor-board/InvestorStatisticsPage.vue');
// Investor internal maintenance
const InvestorInternalMaintenance = () => import(/* webpackChunkName: "investor-internal-maintenance" */ '../../pages/investor-internal-maintenance/InvestorInternalMaintenance.vue');
const InvestorInternalMaintenanceList = () => import(/* webpackChunkName: "investor-internal-maintenance" */ '../../pages/investor-internal-maintenance/InvestorInternalMaintenanceList.vue');
// Investor-auto
const InvestorAutoPage = () => import(/* webpackChunkName: "investor-auto" */ '../../pages/investor-auto/InvestorAutoPage.vue');
const InvestorAutoListPage = () => import(/* webpackChunkName: "investor-auto" */ '../../pages/investor-auto/InvestorAutoListPage.vue');
// Employees
const EmployeesPage = () => import(/* webpackChunkName: "employees" */ '../../pages/employees/EmployeesPage.vue');
const EmployeesListPage = () => import(/* webpackChunkName: "employees-list" */ '../../pages/employees/EmployeesListPage.vue');
// Roles
const RolesPage = () => import(/* webpackChunkName: "roles" */ '../../pages/roles/RolesPage.vue');
const RolesListPage = () => import(/* webpackChunkName: "roles" */ '../../pages/roles/RolesListPage.vue');
const AddRolePage = () => import(/* webpackChunkName: "roles" */ '../../pages/roles/AddRolePage.vue');
const EditRolePage = () => import(/* webpackChunkName: "roles" */ '../../pages/roles/EditRolePage.vue');
// Parks
const ParksPage = () => import(/* webpackChunkName: "parks" */ '../../pages/parks/ParksPage.vue');
const ParksListPage = () => import(/* webpackChunkName: "parks-list" */ '../../pages/parks/ParksListPage.vue');
// Rates
const RatesPage = () => import(/* webpackChunkName: "rates" */ '../../pages/rates/RatesPage.vue');
const RatesListPage = () => import(/* webpackChunkName: "rates" */ '../../pages/rates/RatesListPage.vue');
// Investor report
const InvestorReportPage = () => import(/* webpackChunkName: "investor-report" */ '../../pages/investor-report/InvestorReportPage.vue');
const InvestorReportListPage = () => import(/* webpackChunkName: "investor-report" */ '../../pages/investor-report/InvestorReportListPage.vue');
const InvestorByIdPage = () => import(/* webpackChunkName: "investor-report" */ '../../pages/investor-report/InvestorByIdPage.vue');
const InvestorByIdInfoPage = () => import(/* webpackChunkName: "investor-report" */ '../../pages/investor-report/InvestorInfoPage.vue');
// Investor DTP
const InvestorDtpPage = () => import(/* webpackChunkName: "investor-dtp" */ '../../pages/investor-dtp/InvestorDtpPage.vue');
const InvestorDtpListPage = () => import(/* webpackChunkName: "investor-dtp" */ '../../pages/investor-dtp/InvestorDtpListPage.vue');
// Fines
const FinesPage = () => import(/* webpackChunkName: "fines" */ '../../pages/fines/FinesPage.vue');
const FinesListPage = () => import(/* webpackChunkName: "fines" */ '../../pages/fines/FinesListPage.vue');
const FinesPageV2 = () => import(/* webpackChunkName: "fines" */ '../../pages/fines/FinesPageV2.vue');
const FinesListPageV2 = () => import(/* webpackChunkName: "fines" */ '../../pages/fines/FinesListPageV2.vue');
// Appeals
const AppealsPage = () => import(/* webpackChunkName: "appeals" */ '../../pages/appeals/AppealsPage.vue');
const AppealsListPage = () => import(/* webpackChunkName: "appeals" */ '../../pages/appeals/AppealsListPage.vue');
const AppealPage = () => import(/* webpackChunkName: "appeals" */ '../../pages/appeals/AppealPage');
const AppealInfoPage = () => import(/* webpackChunkName: "appeals" */ '../../pages/appeals/AppealInfoPage');
// Dtp
const DtpPage = () => import(/* webpackChunkName: "dtp" */ '../../pages/dtp/DtpPage.vue');
const DtpListPage = () => import(/* webpackChunkName: "dtp" */ '../../pages/dtp/DtpListPage.vue');
const AddDtpPage = () => import(/* webpackChunkName: "dtp" */ '../../pages/dtp/AddDtpPage.vue');
// Suppliers page
const SuppliersPage = () => import(/* webpackChunkName: "suppliers" */ '../../pages/suppliers/SuppliersPage.vue');
const SuppliersListPage = () => import(/* webpackChunkName: "suppliers" */ '../../pages/suppliers/SuppliersListPage.vue');
// Weekend scheldule
const WeekendSchedulePage = () => import(/* webpackChunkName: "weekend-scheldule" */ '../../pages/weekend-schedule/WeekendSchedulePage.vue');
const WeekendScheldueListPage = () => import(/* webpackChunkName: "weekend-scheldule" */ '../../pages/weekend-schedule/WeekendScheduleListPage.vue');
// Mechanic
const MechanicPage = () => import(/* webpackChunkName: "mechanic" */ '../../pages/mechanic/MechanicPage.vue');
const MechanicRentsListPage = () => import(/* webpackChunkName: "mechanic" */ '../../pages/mechanic/MechanicRentsListPage.vue');
const AcceptAutoPage = () => import(/* webpackChunkName: "mechanic" */ '../../pages/mechanic/AcceptAutoPage.vue');
// Not Found
const NotFoundPage = () => import(/* webpackChunkName: "dashboard" */ '../../pages/NotFoundPage');

/* eslint-disable */
export default {
  path: '',
  name: 'dashboard',
  component: MainLayout,
  redirect : () => {
    console.log(store.getters['global/getRole'])
    if (store.getters['global/getRole'] === 'mechanic') {
      return 'mechanic'
    } else if (store.getters['global/getRole'] === 'investor') {
      return 'investor-board'
    } else {
      return ' workers-board'
    }
  },
  children: [
    {
      path: 'rents',
      component: RentsPage,
      redirect: { name: 'rents-list' },
      children: [
        {
          path: 'rents-list',
          name: 'rents-list',
          component: RentsListPage,
        },
        {
          path: ':rentId',
          name: 'rent',
          component: RentPage,
        },
      ],
    },
    {
      path: 'bookings',
      component: BookingsPage,
      redirect: { name: 'bookings-list' },
      children: [
        {
          path: 'bookings-list',
          name: 'bookings-list',
          component: BookingsListPage,
        },
      ],
    },
    {
      path: 'investors',
      component: InvestorsPage,
      redirect: { name: 'investors-list' },
      children: [
        {
          path: 'investors-list',
          name: 'investors-list',
          component: InvestorsListPage,
        },
        {
          path: 'add',
          name: 'add-investor',
          component: AddInvestorPage,
        },
        {
          path: ':investorId',
          component: InvestorPage,
          redirect: { name: 'investor-info' },
          children: [
            {
              path: 'info',
              name: 'investor-info',
              component: InvestorInfoPage,
            },
            {
              path: 'autos',
              name: 'investor-autos',
              component: InvestorAutosPage,
            },
          ],
        },
      ],
    },
    {
      path: 'investor-report',
      component: InvestorReportPage,
      redirect: { name: 'investor-report-list' },
      children: [
        {
          path: 'investor-report-list',
          name: 'investor-report-list',
          component: InvestorReportListPage,
        },
        {
          path: ':investorId',
          name: 'investor-id',
          redirect: 'investor-id-info',
          component: InvestorByIdPage,
          children: [
            {
              path: 'info',
              name: 'investor-id-info',
              component: InvestorByIdInfoPage,
            },
          ],
        },
      ],
    },
    {
      path: 'drivers',
      component: DriversPage,
      redirect: { name: 'drivers-list' },
      children: [
        {
          path: 'drivers-list',
          name: 'drivers-list',
          component: DriversListPage,
        },
        {
          path: 'add',
          name: 'add-driver',
          component: AddDriverPage,
        },
        {
          path: 'rating-configurator',
          name: 'rating-configurator',
          component: RatingConfiguratorPage,
        },
        {
          path: ':driverId',
          component: DriverPage,
          redirect: { name: 'driver-info' },
          children: [
            {
              path: 'info',
              name: 'driver-info',
              component: DriverInfoPage,
            },
            {
              path: 'autos',
              name: 'driver-autos',
              component: DriverAutosPage,
            },
            {
              path: 'balance',
              name: 'driver-balance',
              component: DriverBalancePage,
            },
            {
              path: 'history',
              name: 'driver-history',
              component: DriverHistoryPage,
            },
            {
              path: 'fines',
              name: 'driver-fines',
              component: DriverFinesPage,
            },
            {
              path: 'dtp',
              name: 'driver-dtp',
              component: DriverDtpPage,
            },
            {
              path: 'rating',
              name: 'driver-rating',
              component: DriverRatingPage,
            },
          ],
        },
      ],
    },
    {
      path: 'autos',
      component: AutosPage,
      redirect: { name: 'autos-list' },
      children: [
        {
          path: 'autos-list',
          name: 'autos-list',
          component: AutosListPage,
        },
        {
          path: 'add',
          name: 'add-auto',
          component: AddAutoPage,
        },
        {
          path: 'insurance-inspection',
          name: 'insurance-inspection',
          component: InsuranceInspectionPage,
        },
        {
          path: 'maintenance-history',
          name: 'maintenance-history',
          component: MaintenanceHistoryPage,
        },
        {
          path: 'internal-maintenance',
          name: 'internal-maintenance',
          component: InternalMaintenancePage,
        },
        {
          path: ':autoId',
          component: AutoPage,
          redirect: { name: 'auto-info' },
          children: [
            {
              path: 'info',
              name: 'auto-info',
              component: AutoInfoPage,
            },
            {
              path: 'current-state',
              name: 'auto-current-state',
              component: AutoCurrentStatePage,
            },
            {
              path: 'rents',
              name: 'auto-rents',
              component: AutoRentsPage,
            },
            {
              path: 'history',
              name: 'auto-history',
              component: AutoHistoryPage,
            },
            {
              path: 'rates',
              name: 'auto-rates',
              component: AutoRatesPage,
            },
            {
              path: 'fines',
              name: 'fines',
              component: AutoFinesPage,
            },
            {
              path: 'dtp',
              name: 'dtp',
              component: AutoDtpPage,
            },
            {
              path: 'internal-maintenance',
              name: 'auto-internal-maintenance',
              component: AutoInternalMaintenancePage,
            }
          ],
        },
      ],
    },
    {
      path: 'workers-board',
      component: WorkersBoard,
      redirect: { name: 'workers-board-list' },
      children: [
        {
          path: 'workers-board-list',
          name: 'workers-board-list',
          component: WorkersBoardList,
        },
        {
          path: 'history',
          name: 'workers-board-history',
          component: WorkersHistoryPage,
        },
        {
          path: 'statistics',
          name: 'workers-board-statistics',
          component: WorkersStatisticsPage,
        }
      ],
    },
    {
      path: 'investor-board',
      component: InvestorBoard,
      redirect: { name: 'investor-board-list' },
      children: [
        {
          path: 'investor-board-list',
          name: 'investor-board-list',
          component: InvestorBoardList,
        },
        {
          path: 'statistics',
          name: 'investor-statistics',
          component: InvestorStatistics,
        },
      ],
    },
    {
      path: 'investor-dtp',
      component: InvestorDtpPage,
      redirect: { name: 'investor-dtp-list' },
      children: [
        {
          path: 'investor-dtp-list',
          name: 'investor-dtp-list',
          component: InvestorDtpListPage,
        },
      ],
    },
    {
      path: 'investor-internal-maintenance',
      name: 'investor-internal-maintenance',
      component: InvestorInternalMaintenance,
      redirect: { name: 'investor-internal-maintenance-list' },
      children: [
        {
          path: 'investor-internal-maintenance-list',
          name: 'investor-internal-maintenance-list',
          component: InvestorInternalMaintenanceList,
        },
      ],
    },
    {
      path: 'investor-auto',
      component: InvestorAutoPage,
      redirect: { name: 'investor-auto-list' },
      children: [
        {
          path: 'investor-auto-list',
          name: 'investor-auto-list',
          component: InvestorAutoListPage,
        },
      ],
    },
    {
      path: 'suppliers',
      component: SuppliersPage,
      redirect: { name: 'suppliers-list' },
      children: [
        {
          path: 'suppliers-list',
          name: 'suppliers-list',
          component: SuppliersListPage,
        },
      ],
    },
    {
      path: 'employees',
      component: EmployeesPage,
      redirect: { name: 'employees-list' },
      children: [
        {
          path: 'employees-list',
          name: 'employees-list',
          component: EmployeesListPage,
        },
      ],
    },
    {
      path: 'parks',
      component: ParksPage,
      redirect: { name: 'parks-list' },
      children: [
        {
          path: 'parks-list',
          name: 'parks-list',
          component: ParksListPage,
        },
      ],
    },
    {
      path: 'roles',
      component: RolesPage,
      redirect: { name: 'roles-list' },
      children: [
        {
          path: 'roles-list',
          name: 'roles-list',
          component: RolesListPage,
        },
        {
          path: 'add',
          name: 'add-role',
          component: AddRolePage,
        },
        {
          path: 'edit/:id',
          name: 'edit-role',
          component: EditRolePage,
        },
      ],
    },
    {
      path: 'rates',
      component: RatesPage,
      redirect: { name: 'rates-list' },
      children: [
        {
          path: 'rates-list',
          name: 'rates-list',
          component: RatesListPage,
        },
      ],
    },
    {
      path: 'fines',
      component: FinesPage,
      redirect: { name: 'fines-list' },
      children: [
        {
          path: 'fines-list',
          name: 'fines-list',
          component: FinesListPage,
        },
      ],
    },
    {
      path: 'fines',
      component: FinesPageV2,
      redirect: { name: 'fines-list-v2' },
      children: [
        {
          path: 'fines-list-v2',
          name: 'fines-list-v2',
          component: FinesListPageV2,
        },
      ],
    },
    {
      path: 'appeals',
      component: AppealsPage,
      redirect: { name: 'appeals-list' },
      children: [
        {
          path: 'appeals-list',
          name: 'appeals-list',
          component: AppealsListPage,
        },
        {
          path: ':appealId',
          component: AppealPage,
          redirect: { name: 'appeal-info' },
          children: [
            {
              path: 'info',
              name: 'appeal-info',
              component: AppealInfoPage,
            },
          ],
        },
      ],
    },
    {
      path: 'dtp',
      component: DtpPage,
      redirect: { name: 'dtp-list' },
      children: [
        {
          path: 'dtp-list',
          name: 'dtp-list',
          component: DtpListPage,
        },
        {
          path: 'add',
          name: 'dtp-add',
          component: AddDtpPage,
        },
      ],
    },
    {
      path: 'finance',
      component: FinancePage,
      redirect: { name: 'company-expenses' },
      children: [
        {
          name: 'company-expenses',
          path: 'company-expenses',
          component: CompanyExpensesPage,
        },
        {
          name: 'configurator',
          path: 'company-expenses/configurator',
          component: ConfiguratorPage,
        },
        {
          name: 'company-expenses-history',
          path: 'company-expenses/history',
          component: CompanyExpensesHistoryPage,
        },
      ],
    },
    {
      path: 'settings',
      component: SettingsPage,
      redirect: { name: 'companies-list' },
      children: [
        {
          path: 'companies',
          component: CompaniesPage,
          redirect: { name: 'companies-list' },
          children: [
            {
              path: 'companies-list',
              name: 'companies-list',
              component: CompaniesListPage,
            },
            {
              path: 'add',
              name: 'add-company',
              component: AddCompanyPage,
            },
            {
              path: ':companyId',
              component: CompanyPage,
            },
          ],
        },
      ],
    },
    {
      path: 'weekend-schedule',
      component: WeekendSchedulePage,
      redirect: { name: 'weekend-schedule-list' },
      children: [
        {
          path: 'weekend-schedule-list',
          name: 'weekend-schedule-list',
          component: WeekendScheldueListPage,
        },
      ]
    },
    {
      path: 'mechanic',
      name: 'mechanic',
      component: MechanicPage,
      redirect: { name: 'mechanic-rents' },
      children: [
        {
          path: 'rents',
          name: 'mechanic-rents',
          component: MechanicRentsListPage,
        },
        {
          path: 'accept-auto/:carId',
          name: 'mechanic-accept-auto',
          component: AcceptAutoPage,
        }
      ]
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFoundPage,
    },
    {
      path: '*',
      redirect: '/not-found',
    },
  ],
};
